import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Note } from '../../../helbest';
import { API } from '../../../request/api';

const useLogin = (Login, loginUser) => {
  const [firstPage, setFirstPage] = useState(true);
  const [phone, setPhone] = useState('');
  const [userCaptcha, setUserCaptcha] = useState('');
  const [userOtp, setUserOtp] = useState('');
  const [captchaImg, setCaptchaImg] = useState('');
  const [captchaUuid, setCaptchaUuid] = useState('');

  const [phone_error, set_phone_error] = useState(false);
  const [security_error, set_security_error] = useState(false);

  const history = useHistory();
  const params = useParams();

  const check_user = () => {
    if (Login.is_login) {
      history.push('/');
    }
  };

  const Recapcha = () => {
    API.get
      .captcha('ffffff', '000000', '5c6d96')
      .then((response) => {
        if (response.success) {
          setCaptchaImg(response.data.image_str);
          setCaptchaUuid(response.data.captcha_uuid);
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
    return 2;
  };

  const new_recapcha = () => {
    setCaptchaImg('');
    setCaptchaUuid('');
    Recapcha();
  };

  const send_code = () => {
    if (phone.length < 11 || phone === '') {
      set_phone_error(true);
      return;
    }
    set_phone_error(false);

    if (userCaptcha.length !== 4) {
      set_security_error(true);
      return;
    }

    // send sms
    API.post
      .sendOtp(phone, Login.city_id, captchaUuid, userCaptcha)
      .then((response) => {
        if (response.success) {
          setFirstPage(false);
        } else {
          setFirstPage(true);
          setCaptchaImg('');
          setCaptchaUuid('');
          setUserOtp('');
          setUserCaptcha('');
          Recapcha();
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        setFirstPage(true);
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
  };

  const check_code = () => {
    if (userOtp === '') {
      Note.error('لطفا کد تایید خود را وارد کنید.');
      return;
    }

    if (userOtp.length === 6) {
      API.post
        .checkOtp(phone, userOtp)
        .then(async (response) => {
          if (response.success) {
            localStorage.setItem('carfillo', response.data.token);

            loginUser({
              token: response.data.token,
              phone_number: phone,
              credit: response.data.credit,
              last_name: response.data.last_name,
              first_name: response.data.first_name
            });

            try {
              if (params.route === 'p') {
                history.push('/delivery/');
              } else {
                history.push('/');
              }
            } catch {
              history.push('/');
            }
          } else {
            setFirstPage(true);
            setCaptchaImg('');
            setCaptchaUuid('');
            setUserOtp('');
            setUserCaptcha('');

            Recapcha();
            Note.error(response.message);
          }
          return response;
        })
        .catch((error) => {
          setFirstPage(true);
          // eslint-disable-next-line no-console
          console.error('Error : ', error);
        });
    } else {
      Note.error('کد تائید شما صحیح نیست.');
      setFirstPage(true);
    }
  };

  useEffect(() => {
    check_user();
    Recapcha();
  }, []); // eslint-disable-line

  return [
    firstPage,
    setFirstPage,
    phone,
    setPhone,
    userCaptcha,
    setUserCaptcha,
    userOtp,
    setUserOtp,
    captchaImg,
    phone_error,
    set_phone_error,
    security_error,
    set_security_error,
    Recapcha,
    new_recapcha,
    send_code,
    check_code
  ];
};

export default useLogin;
